import { companyCustomerServiceGrades } from '@models/Company';
import { contactBase } from '@models/Contact';
import { country } from '@models/Country';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const member = t.type({
  id: t.number,
  user: h.omittable(
    t.type({
      id: t.number,
      landline: t.string,
      cellphone: t.string,
      email: t.string,
      last_name: t.string,
      first_name: t.string,
    }),
  ),
  country: h.omittable(country),
  member_no: h.omittable(t.string),
  created_at: t.string,
  company_name: h.omittable(t.string),
  salesperson_name: h.omittable(t.string),
  salesperson_last_name: h.omittable(t.string),
  representer_last_name: h.omittable(t.string),
  representer_first_name: h.omittable(t.string),
  customer_service_grades: companyCustomerServiceGrades,
  contact: h.omittable(contactBase),
  has_unverified_email: h.omittable(t.boolean),
});

export type Member = t.TypeOf<typeof member>;

export const memberUser = t.type({
  id: t.number,
  date_joined: t.string,
  company_name: h.omittable(t.string),
  customer_assignee_name: h.omittable(t.string),
  email: t.string,
  cellphone: t.string,
  login_status: h.omittable(t.string),
  first_name: t.string,
  last_name: t.string,
  sns_id: t.string,
  member_no: h.omittable(t.string),
  company_id: h.omittable(t.number),
});

export type MemberUser = t.TypeOf<typeof memberUser>;

export const memberUserStatus = t.union([
  t.literal('審査中'),
  t.literal('登録済'),
  t.literal('未登録'),
]);

export const allMemberUserStatus = memberUserStatus.types.map((l) => l.value);

export const memberUserLevel = t.union([
  t.literal('A'),
  t.literal('B'),
  t.literal('C'),
  t.literal('S'),
  t.literal('X'),
]);

export const allMemberUserLevel = memberUserLevel.types.map((l) => l.value);

export const dashboardMemberQuery = t.partial({
  page: h.number().cast(),
  page_size: h.number().cast(),
  member_no: t.string,
  company_name: t.string,
  salesperson_name: t.string,
  email: t.string,
  created_at_before: t.string,
  created_at_after: t.string,
  ordering: t.array(t.string),
  is_staff: t.boolean,
  route_plan_id: t.number,
  fullname: t.string,
});

export type DashboardMemberQuery = t.TypeOf<typeof dashboardMemberQuery>;
